export class MedicamentLivre {
    id_med_liv: number;
    resp_grand_stock: string;
    chef_pharma: string;
    demandeur :any;
    lieu:any;
    date_med_liv: Date;
    file_med_liv:any;
    libelle_med_liv:any;
    med_valide:any;
    etat_medicament:any;
    consommable:any;
    constructor(id_med_liv: number) { }
}

